import React from 'react';

import classes from './InputError.module.css';

const inputError = (props) => (
  <p className={classes.Error} style={props.style}>{props.children}</p>
);

export default inputError;
